import { sharedData } from "../sharedData/sharedData";

class Observalbe {
    constructor(key) {
        this.key = key;
        this.subscribers = [];
        this.value = "";
    }

    subscribe(callback) {
        this.subscribers.push(callback);
        if (this.value) {
            callback(this.value);
        }
        return () => {
            this.subscribes = this.subscribers.filter(sub => sub !== callback);
        }
    }

    setValue(value, by) {
        this.value = value;
        sharedData.set(this.key, this.value);
        sharedData.set(this.key + "-by", by);
        this.subscribers.forEach(callback => callback(value));
    }

    getValue() {
        return sharedData.get(this.key);
    }

    getBy() {
        return sharedData.get(this.key + "-by");
    }
};

export const diligenceTypeObservable = new Observalbe("diligenceStatus");